import { isService } from '../save/metadata'
import { useMixedMediaCapability } from './useMixedMediaCapability'
import type { MixedMediaCapability } from './mixedMediaCapability'

const NO_CAPABILITY: MixedMediaCapability = {
  canMixMediaTypes: false,
  canHaveMultipleVideos: false,
}

/**
 * Looks up mixed-media capability for a legacy `Draft.service.name` string
 * (e.g. `'twitter'`), which matches the GraphQL `Service` union's values
 * exactly. Callers that already hold a typed `Service` should use
 * {@link useMixedMediaCapability}'s `forService` directly instead.
 *
 * The channel-less `'omni'` draft bypasses the per-network allowlist —
 * its destination channel isn't chosen yet — but still respects the
 * org-level rollout flag.
 */
export function useMixedMediaCapabilityForService(
  serviceName: string,
): MixedMediaCapability {
  const { orgEnabled, forService } = useMixedMediaCapability()

  if (serviceName === 'omni') {
    return { canMixMediaTypes: orgEnabled, canHaveMultipleVideos: orgEnabled }
  }

  return isService(serviceName) ? forService(serviceName) : NO_CAPABILITY
}
